import React from 'react';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../incase-domain/components/button/Button';
import {copyToClipboard} from '../../../../../utils/copyToClipboard';

interface IPresentationLinkProps {
    link: string;
    dataCy?: string;
}

function PresentationLink({link, dataCy}: IPresentationLinkProps): JSX.Element {
    const {t} = useTranslation();

    async function handleCopyLink(copyLink?: string): Promise<void> {
        try {
            if (copyLink) await copyToClipboard(copyLink);
            toast.info(t('presEditPage.subNavBar.copiedToClipboard'));
        } catch (err) {
            toast.info(t('presEditPage.subNavBar.failedToCopy'));
        }
    }

    return (
        <Button
            color="info"
            variant="soft"
            size="sm"
            onClick={() => handleCopyLink(link)}
            trailing="solar:copy-linear"
            dataCy={dataCy}
            disabled={!link}
            data-link={link}
        >
            {t('editorPage.createPresentationLinksModal.copyLink')}
        </Button>
    );
}

export default PresentationLink;
